import { render, staticRenderFns } from "./ProductListGrid.vue?vue&type=template&id=50ec3afc"
import script from "./ProductListGrid.vue?vue&type=script&lang=js"
export * from "./ProductListGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports